import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Popover } from '@mui/material';
import { appColors } from '../assets/appColors';
var RoundedTriangle = function () { return (_jsx("svg", { width: "22", height: "25", viewBox: "0 0 22 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: SVGTriangleStyle, children: _jsx("path", { d: "M1.75 10.3349C0.0833308 11.2972 0.0833333 13.7028 1.75 14.6651L17.5 23.7583C19.1667 24.7206 21.25 23.5178 21.25 21.5933L21.25 3.40673C21.25 1.48223 19.1667 0.279418 17.5 1.24167L1.75 10.3349Z", fill: "black", stroke: "black" }) })); };
export var BackrsPopover = function (_a) {
    var anchorId = _a.anchorId, isPopoverOpen = _a.isPopoverOpen, setIsPopoverOpen = _a.setIsPopoverOpen, children = _a.children;
    return (_jsx(Popover, { open: isPopoverOpen, anchorEl: document.getElementById(anchorId), onClose: function () { return setIsPopoverOpen(false); }, transformOrigin: { vertical: 'center', horizontal: 'right' }, onClick: function () { return setIsPopoverOpen(false); }, PaperProps: {
            sx: paperSx,
        }, children: _jsxs(_Fragment, { children: [_jsx(RoundedTriangle, {}), children] }) }));
};
var paperSx = {
    fontSize: '12pt',
    padding: 2,
    maxWidth: '300px',
    backgroundColor: appColors.neutral.black,
    color: appColors.neutral.white,
    borderRadius: 4,
    whiteSpace: 'pre-wrap',
    overflow: 'visible',
    marginLeft: '-20px',
};
var SVGTriangleStyle = {
    position: 'absolute',
    top: 'calc(50% - 12px)',
    right: '-16px',
    transform: 'rotate(180deg)',
};
